import { Pencil } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { checkObservationFormType } from "src/utils/checkObservationFormType";
import { useAdminForm } from "src/hooks/admin/useAdminForm";
import EditObservationQuestionsForm from "src/containers/EditObservationQuestionsForrm/EditObservationQuestionsForms";
import { Button } from "src/components/ui/button";

export interface EditObservationQuestionProps {}

const EditObservationQuestions = ({}: EditObservationQuestionProps) => {
	const navigate = useNavigate();
	const params = useParams<{ formId: number }>();

	const observationFormId = params.formId;

	const { data: form, isLoading: isLoadingForm } = useAdminForm(
		observationFormId,
		{
			enabled: Boolean(observationFormId)
		}
	);

	const handleEditFormSettingsClick = () => {
		navigate(`/observations/forms/${observationFormId}/settings`);
	};

	return (
		<div>
			<div className="flex items-center justify-between mb-6">
				{isLoadingForm && (
					<div className="flex flex-col gap-2">
						<div className="h-6 w-80 rounded bg-muted animate-pulse" />
					</div>
				)}

				{form && (
					<h2 className="font-heading text-lg font-medium text-foreground line-clamp-2 max-w-[560px]">
						{form.name}
					</h2>
				)}

				<Button
					variant="outline"
					onClick={handleEditFormSettingsClick}
					className="flex items-center gap-2"
				>
					<Pencil size={16} />
					Edit form settings
				</Button>
			</div>

			{form && (
				<div className="rounded-xl border border-primary-light/30 bg-primary-lighter p-4 mb-6">
					<p className="text-sm text-foreground">
						<span className="font-medium">Note:</span> When the form is
						published you will have the option to select the{" "}
						{checkObservationFormType(form.observation_type) === "user"
							? "employee"
							: "store"}{" "}
						you are observing.
					</p>
				</div>
			)}

			<EditObservationQuestionsForm observationFormId={observationFormId} />
		</div>
	);
};

export default EditObservationQuestions;
